import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import { ListItem } from '@/components/list-item';
import { StyleProp, Text, ViewStyle } from 'react-native';
import { Switch, Props as SwitchProps } from '@/components/switch';

type Props = SwitchProps & {
  listItemStyle?: StyleProp<ViewStyle>;
};

export const AdminToggleRow: React.FC<Props> = ({
  listItemStyle,
  ...switchProps
}) => {
  const [styles] = useStyles();
  return (
    <ListItem
      item={{
        subtitle: (
          <Text style={styles.subtitleText}>
            {i18n.t('admin_access.description')}
          </Text>
        ),
        title: i18n.t('admin_access.title'),
        value: 'admin-toggle',
      }}
      listItemStyle={listItemStyle}
      renderRightComponent={() => {
        return <Switch {...switchProps} />;
      }}
    />
  );
};

const useStyles = createStyles((theme) => ({
  subtitleText: {
    ...FONTS.primary,
    color: theme.colors.inactiveText,
    fontSize: 12,
    lineHeight: 14,
  },
}));
